import React from 'react';
import PropTypes from 'prop-types';
import { MarkerDetailContent } from './marker_detail/content';
import { MarkerDetailWrapper } from '../wrappers/marker_detail_wrapper';
import { MarkerDetailTitle } from './marker_detail/title';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import AutoCompleteInput from './search';

function SearchHeading({
  title,
  description,
  subdescription,
  icon = <LightbulbOutlinedIcon />,
  isLoaded,
}) {
  return (
    <>
      <MarkerDetailWrapper
        style={{
          position: 'sticky',
          top: 0,
          overflow: 'unset',
          zIndex: 3,
          backgroundColor: 'white',
          width: '98%',
          margin: 0,
        }}
      >
        <MarkerDetailTitle>{title}</MarkerDetailTitle>
        <MarkerDetailContent>
          {icon}
          <p>{description}</p>
          <p style={{ color: '#1C66AD' }}>{subdescription}</p>
          <AutoCompleteInput isLoaded={isLoaded} />
        </MarkerDetailContent>
      </MarkerDetailWrapper>
    </>
  );
}

SearchHeading.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  subdescription: PropTypes.string,
  icon: PropTypes.string,
  isLoaded: PropTypes.bool,
};

export default SearchHeading;
